import { CSSProperties, FC, useContext } from 'react'
import SVG from 'react-inlinesvg'
import { lock, star } from '../../assets/icon'
import { Icon, Text, TextSecond, Thumb, Decor } from './Discount.styled'
import { QuizContext } from '../../providers/QuizProvider/QuizContext'
import { useTranslation } from '../../hooks/useTranslation'

type Props = {
    style?: CSSProperties
    addition: any
    lockBonus: boolean
    disabledDecor?: boolean
}

export const Discount: FC<Props> = ({ style, lockBonus, disabledDecor, addition: { image, title, config } }) => {
    const { t } = useTranslation()
    const { currency } = useContext(QuizContext)

    const discountTitle =
        config?.unitDiscount === 2 ? `${config?.discountValue}${currency?.title ?? ''}` : `${config?.discountValue}%`

    return (
        <Thumb image={image} style={style}>
            <Icon>
                {lockBonus ? (
                    <SVG src={lock} width={13} height={13} />
                ) : (
                    <SVG style={{ color: 'var(--bg-button)' }} src={star} width={13} height={13} />
                )}
            </Icon>
            <Text>{t('discount')}</Text>
            <TextSecond>{discountTitle}</TextSecond>
            {!disabledDecor ? <Decor /> : null}
        </Thumb>
    )
}
